import { IMDSMenuProps } from "./menu.types";
import styled from "@emotion/styled";
import { Menu } from "react-aria-components";

// Default themed styling for the root menu container.
export const StyledMenu = styled(Menu)<IMDSMenuProps>();
